import CounterCheckout from '@/api/restaurant-sale/counter-checkout'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  tables: [],
  customer_member_cards: [],
  inviceLists: [],
  tableSelected: {},
  cancelOrder: {},
  num_customer: 0,
  date_from: moment().add(-1, 'day').startOf('day').format('DD-MM-YYYY HH:mm'),
  date_to: moment().endOf('day').format('DD-MM-YYYY HH:mm'),
  lock: true
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_TABLES(state, data) {
    state.tables = data
  },
  RECEIVE_TABLE_SELECTED(state, data) {
    state.tableSelected = data
  },
  SET_NUMBER_CUSTOMERS(state, data) {
    state.num_customer = data
  },
  RECEIVE_CUSTOMER_MEMBER_CARD(state, data) {
    state.customer_member_cards = data
  },
  RECEIVE_INVOICE_LIST(state, data) {
    state.inviceLists = data
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_LOCK(state, data) {
    state.lock = data
  },

}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return CounterCheckout.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return CounterCheckout.store(data)
  },
  destroy(context, { id, data }) {
    return CounterCheckout.destroy(id, data)
  },
  fetchTables(context, attributes) {
    return CounterCheckout.getTable({
      params: attributes
    }).then(response => {
      context.commit('RECEIVE_TABLES', response.data)
      return Promise.resolve(response)
    })
  },
  combineTable(context, attributes) {
    return CounterCheckout.combineTable({
      params: {
        stock_out_from_id: attributes.stock_out_from_id,
        stock_out_to_id: attributes.stock_out_to_id,
        table_from_id: attributes.table_from_id,
        is_clean_from_table: attributes.is_clean_from_table
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  splitOrder(context, payload) {
    return CounterCheckout.splitOrder(payload).then(response => {
      return Promise.resolve(response.data)
    })
  },
  moveTable(context, attributes) {
    return CounterCheckout.moveTable({
      params: {
        stock_out_id: attributes.stock_out_id,
        to_table_id: attributes.table_to_id,
        reason: attributes.reason
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  cleanTable(context, table_id) {
    return CounterCheckout.cleanTable({
      params: {
        table_id: table_id
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  isCustomerCome(context, booking_id) {
    return CounterCheckout.isCustomerCome({
      params: {
        booking_id: booking_id
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  shiftClose(context, data) {
    return CounterCheckout.shiftClose(data).then(response => {
      return Promise.resolve(response)
    })
  },
  previewPdf(context, id) {
    return CounterCheckout.printPDF(id)
  },
  printBill(context, attributes = {}) {
    return CounterCheckout.printBill({
      params: attributes
    })
  },
  paymentMethod(context, attributes = {}) {
    return CounterCheckout.paymentMethod()
  },
  bankProfile(context, attributes = {}) {
    return CounterCheckout.bankProfile()
  },
  cancelOrder(context, { stock_out_id, data }) {
    return CounterCheckout.cancelOrder(stock_out_id, data)
  },
  linkedKey(context, data) {
    return CounterCheckout.linkedKey(data)
  },
  serviceDurationDetail(context, data) {
    return CounterCheckout.serviceDurationDetail(data)
  },
  remarks(context, attributes = {}) {
    return CounterCheckout.remarks()
  },
  fetchCustomerMemberCard(context, attributes) {
    return CounterCheckout.getCustomerMemberCard({
      params: attributes
    }).then(response => {
      context.commit('RECEIVE_CUSTOMER_MEMBER_CARD', response.data)
      return Promise.resolve(response)
    })
  },
  fetchInvoiceList(context, attributes) {
    return CounterCheckout.getInvoiceList({
      params: attributes
    }).then(response => {
      context.commit('RECEIVE_INVOICE_LIST', response.data)
      return Promise.resolve(response)
    })
  },
  fetchFloating(context, attributes) {
    return CounterCheckout.getFloating({ params: attributes })
  },
  updatePreChargePayment(_, { stock_out_id, data }) {
    return CounterCheckout.updatePreChargePayment(stock_out_id, data)
  },
}
